module.exports = __webpack_public_path__ + "static/media/greenhouse3-06.d88d585b.webp";